import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Listings } from 'containers/AppContainer/typings';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import ProcedureInformation from 'containers/LawyerLegalProceedingsPage/judgementAdd/ProcedureInformation';
import { get } from 'lodash';
import CivilParty from 'containers/LawyerLegalProceedingsPage/judgementAdd/CivilParty';
import JudgementAddPronouncing from 'containers/LawyerLegalProceedingsPage/judgementAdd/JudgementAddPronouncing';
export interface JudgementAddFormProps {
  intl: IntlShape;
  listings: Listings;
  policyInfo: any;
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadDocumentStore: Function;
  isCivilProceeding: boolean;
  procedureInstance: any;
  setProcedureInstance: Function;
  victims: any;
  vehicules: any;
  details: any;
  setDetails: Function;
  civilPartyDocuments: any;
  setCivilPartyDocuments: Function;
  judgementAddDocuments: any;
  setJudgementAddDocuments: Function;
  disabled: boolean;
  processInformationValidation: any;
  messageError: any;
  canStartCivilParty: boolean;
  requestGetDocByDocumentumId: Function;
}

export const JudgementAddForm: React.FC<JudgementAddFormProps> = (
  props,
): JSX.Element => {
  return (
    <>
      <ProcedureInformation
        listings={props.listings}
        details={props.details}
        vehicules={props.vehicules}
        setDetails={props.setDetails}
        processInformationValidation={props.processInformationValidation}
        messageError={props.messageError}
        lossDate={get(props.policyInfo, 'sagisInfoClaim.lossDate', '')}
        sagisOpposingParties={null}
        currentJudiciaryProcess={props.procedureInstance}
      />
      {!props.isCivilProceeding && (
        <CivilParty
          victims={props.victims}
          uploadDocument={props.uploadDocument}
          uploadedDocument={props.uploadedDocument}
          civilPartyDocuments={props.civilPartyDocuments}
          setCivilPartyDocuments={props.setCivilPartyDocuments}
          resetUploadedDocument={props.resetUploadDocumentStore}
          canStartCivilParty={props.canStartCivilParty}
          sagisVictimInfo={null}
          isBasicManagement
          imagineDocuments={[]}
          policyInfo={{}}
          listings={props.listings}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        />
      )}
      <JudgementAddPronouncing
        judgementAddDocuments={props.judgementAddDocuments}
        setJudgementAddDocuments={props.setJudgementAddDocuments}
        listings={props.listings}
        victims={props.victims}
        details={props.details}
        vehicules={props.vehicules}
        uploadDocument={props.uploadDocument}
        uploadedDocument={props.uploadedDocument}
        resetUploadedDocument={props.resetUploadDocumentStore}
        disabled={props.disabled}
        sagisVictimInfo={null}
        sagisOpposingParties={null}
        isBasicManagement
        imagineDocuments={[]}
        policyInfo={{}}
        claimId={(null as unknown) as number}
        requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
      />
    </>
  );
};

export default injectIntl(JudgementAddForm);
